export const SET_CURRENT_MODULE = 'SET_CURRENT_MODULE/SALES-CHALLENGE';

export const setCurrentModule = (payload) => {
  return {
    type: SET_CURRENT_MODULE,
    payload,
  };
};
